import React from "react";
import AboutUsTemplate from "./about-us.template";
const AboutUsComponent = () => {
    return (
        <AboutUsTemplate />
    );
};
export default AboutUsComponent;
